export type { L2CarouselProps } from './L2Carousel';
export { L2Carousel } from './L2Carousel';
